// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scope styles only inside SkillRepo */
.skill-repo-container input,
.skill-repo-container .ant-select,
.skill-repo-container .ant-input,
.skill-repo-container .ant-input-textarea,
.skill-repo-container .ant-date-picker {
    width: 100%;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #d9d9d9;
    border-radius: 0px;
}

/* Ensure modal styles only apply within this component */
.skill-repo-container .ant-modal {
    top: 50px;
}

.skill-repo-container .ant-modal-header {
    background-color: #f0f2f5;
    border-bottom: 1px solid #e8e8e8;
}

.skill-repo-container .ant-modal-title {
    font-size: 18px;
    font-weight: 600;
}

.skill-repo-container .ant-modal-footer {
    border-top: 1px solid #e8e8e8;
}

/* Form container */
.skill-repo-container .form-container {
    margin: 20px;
    padding: 20px;
    text-align: center;
}

/* Modal submit button */
.skill-repo-container .custom-submit-button {
    width: 150px;
    height: 45px;
    font-size: 16px;
    font-weight: bold;
    background-color: #1f415b;
    border-radius: 0px !important;
}

.skill-repo-container .custom-submit-button:hover {
    background-color: #40a9ff;
}

/* Fix select dropdown alignment */
.skill-repo-container .ant-select-selector {
    display: flex !important;
    align-items: center !important;
    border: 1px solid #d9d9d9 !important;
}


/* ✅ Force Left Alignment Only Inside SkillRepo */
.skill-repo-container .ant-form-item-label {
    text-align: left !important;
    justify-content: flex-start !important;
    display: flex !important;
    align-items: center !important;
    flex-grow: 1 !important;
    width: auto !important;
    max-width: 100% !important;
    white-space: normal !important; /* Prevents text truncation */
    overflow: visible !important;
}

/* ✅ Override Even Ant Design's Internal Styles */
.skill-repo-container :where(.css-dev-only-do-not-override-xex5fb) .ant-form-item-label {
    text-align: left !important;
    justify-content: flex-start !important;
    display: flex !important;
    align-items: center !important;
    flex-grow: 1 !important;
    width: auto !important;
    max-width: 100% !important;
    white-space: normal !important;
    overflow: visible !important;
}


/* Fix Ant Design multiple select dropdown */
.skill-repo-container .ant-select-multiple .ant-select-selector {
    min-height: 40px !important;
    overflow-y: auto !important;
}

/* Ensure inputs have correct styling */
.skill-repo-container .ant-input,
.skill-repo-container .ant-select-selector {
    height: 40px;
    padding: 4px 10px;
}

/* Upload section */
.skill-repo-container .ant-upload.ant-upload-select-picture-card {
    width: 100%;
}

.skill-repo-container .ant-upload-list-picture-card-container {
    width: 100%;
    text-align: center;
}

/* Button to open modal */
.skill-repo-container .ant-btn {
    width: 100%;
    max-width: 200px;
    font-size: 16px;
    padding: 10px;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
    .skill-repo-container .form-box {
        flex-direction: column;
    }

    .skill-repo-container .form-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .skill-repo-container .label {
        text-align: left;
        width: 100%;
        margin-bottom: 5px;
    }

    .skill-repo-container .input {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/components/SkillsetRepository/SkillRepo.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;;;;;IAKI,WAAW;IACX,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;AACxC;;;AAGA,iDAAiD;AACjD;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,8BAA8B,EAAE,6BAA6B;IAC7D,4BAA4B;AAChC;;AAEA,iDAAiD;AACjD;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,8BAA8B;IAC9B,4BAA4B;AAChC;;;AAGA,4CAA4C;AAC5C;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA,uCAAuC;AACvC;;IAEI,YAAY;IACZ,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* Scope styles only inside SkillRepo */\n.skill-repo-container input,\n.skill-repo-container .ant-select,\n.skill-repo-container .ant-input,\n.skill-repo-container .ant-input-textarea,\n.skill-repo-container .ant-date-picker {\n    width: 100%;\n    padding: 10px;\n    font-size: 14px;\n    border: 1px solid #d9d9d9;\n    border-radius: 0px;\n}\n\n/* Ensure modal styles only apply within this component */\n.skill-repo-container .ant-modal {\n    top: 50px;\n}\n\n.skill-repo-container .ant-modal-header {\n    background-color: #f0f2f5;\n    border-bottom: 1px solid #e8e8e8;\n}\n\n.skill-repo-container .ant-modal-title {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.skill-repo-container .ant-modal-footer {\n    border-top: 1px solid #e8e8e8;\n}\n\n/* Form container */\n.skill-repo-container .form-container {\n    margin: 20px;\n    padding: 20px;\n    text-align: center;\n}\n\n/* Modal submit button */\n.skill-repo-container .custom-submit-button {\n    width: 150px;\n    height: 45px;\n    font-size: 16px;\n    font-weight: bold;\n    background-color: #1f415b;\n    border-radius: 0px !important;\n}\n\n.skill-repo-container .custom-submit-button:hover {\n    background-color: #40a9ff;\n}\n\n/* Fix select dropdown alignment */\n.skill-repo-container .ant-select-selector {\n    display: flex !important;\n    align-items: center !important;\n    border: 1px solid #d9d9d9 !important;\n}\n\n\n/* ✅ Force Left Alignment Only Inside SkillRepo */\n.skill-repo-container .ant-form-item-label {\n    text-align: left !important;\n    justify-content: flex-start !important;\n    display: flex !important;\n    align-items: center !important;\n    flex-grow: 1 !important;\n    width: auto !important;\n    max-width: 100% !important;\n    white-space: normal !important; /* Prevents text truncation */\n    overflow: visible !important;\n}\n\n/* ✅ Override Even Ant Design's Internal Styles */\n.skill-repo-container :where(.css-dev-only-do-not-override-xex5fb) .ant-form-item-label {\n    text-align: left !important;\n    justify-content: flex-start !important;\n    display: flex !important;\n    align-items: center !important;\n    flex-grow: 1 !important;\n    width: auto !important;\n    max-width: 100% !important;\n    white-space: normal !important;\n    overflow: visible !important;\n}\n\n\n/* Fix Ant Design multiple select dropdown */\n.skill-repo-container .ant-select-multiple .ant-select-selector {\n    min-height: 40px !important;\n    overflow-y: auto !important;\n}\n\n/* Ensure inputs have correct styling */\n.skill-repo-container .ant-input,\n.skill-repo-container .ant-select-selector {\n    height: 40px;\n    padding: 4px 10px;\n}\n\n/* Upload section */\n.skill-repo-container .ant-upload.ant-upload-select-picture-card {\n    width: 100%;\n}\n\n.skill-repo-container .ant-upload-list-picture-card-container {\n    width: 100%;\n    text-align: center;\n}\n\n/* Button to open modal */\n.skill-repo-container .ant-btn {\n    width: 100%;\n    max-width: 200px;\n    font-size: 16px;\n    padding: 10px;\n}\n\n/* Responsive Styles */\n@media screen and (max-width: 768px) {\n    .skill-repo-container .form-box {\n        flex-direction: column;\n    }\n\n    .skill-repo-container .form-item {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .skill-repo-container .label {\n        text-align: left;\n        width: 100%;\n        margin-bottom: 5px;\n    }\n\n    .skill-repo-container .input {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
